import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconDataWhisker$1 = /*@__PURE__*/ proxyCustomElement(class WppIconDataWhisker extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-data-whisker", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M12.2205 3.64103C11.8807 3.64103 11.6052 3.91654 11.6052 4.25641C11.6052 4.59628 11.8807 4.87179 12.2205 4.87179H13.041V6.10256H12.6308C11.6112 6.10256 10.7846 6.92912 10.7846 7.94872V13.6923C10.7846 14.7119 11.6112 15.5385 12.6308 15.5385H13.041V16.7692H12.2205C11.8807 16.7692 11.6052 17.0447 11.6052 17.3846C11.6052 17.7245 11.8807 18 12.2205 18H15.0923C15.4322 18 15.7077 17.7245 15.7077 17.3846C15.7077 17.0447 15.4322 16.7692 15.0923 16.7692H14.2718V15.5385H14.6821C15.7017 15.5385 16.5282 14.7119 16.5282 13.6923V7.94872C16.5282 6.92912 15.7017 6.10256 14.6821 6.10256H14.2718V4.87179H15.0923C15.4322 4.87179 15.7077 4.59628 15.7077 4.25641C15.7077 3.91654 15.4322 3.64103 15.0923 3.64103H12.2205ZM12.0154 7.94872C12.0154 7.60885 12.2909 7.33333 12.6308 7.33333H14.6821C15.0219 7.33333 15.2975 7.60885 15.2975 7.94872V9.38462H12.0154V7.94872ZM12.0154 10.6154H15.2975V13.6923C15.2975 14.0322 15.0219 14.3077 14.6821 14.3077H12.6308C12.2909 14.3077 12.0154 14.0322 12.0154 13.6923V10.6154ZM4.83592 2C4.49605 2 4.22054 2.27552 4.22054 2.61538C4.22054 2.95525 4.49605 3.23077 4.83592 3.23077H5.65643V4.46154H5.24618C4.22658 4.46154 3.40002 5.28809 3.40002 6.30769V12.0513C3.40002 13.0709 4.22658 13.8974 5.24618 13.8974H5.65643V15.1282H4.83592C4.49605 15.1282 4.22054 15.4037 4.22054 15.7436C4.22054 16.0835 4.49605 16.359 4.83592 16.359H7.70772C8.04758 16.359 8.3231 16.0835 8.3231 15.7436C8.3231 15.4037 8.04758 15.1282 7.70772 15.1282H6.8872V13.8974H7.29746C8.31706 13.8974 9.14361 13.0709 9.14361 12.0513V6.30769C9.14361 5.28809 8.31706 4.46154 7.29746 4.46154H6.8872V3.23077H7.70772C8.04758 3.23077 8.3231 2.95525 8.3231 2.61538C8.3231 2.27552 8.04758 2 7.70772 2H4.83592ZM5.24618 12.6667C4.90631 12.6667 4.63079 12.3911 4.63079 12.0513V10.6154H7.91285V12.0513C7.91285 12.3911 7.63733 12.6667 7.29746 12.6667H5.24618ZM7.91285 9.38462H4.63079V6.30769C4.63079 5.96782 4.90631 5.69231 5.24618 5.69231H7.29746C7.63733 5.69231 7.91285 5.96782 7.91285 6.30769V9.38462Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-data-whisker-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-data-whisker", "wpp-icon-data-whisker-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-data-whisker-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-data-whisker-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconDataWhisker$1);
      }
      break;
  } });
}

const WppIconDataWhisker = WppIconDataWhisker$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconDataWhisker, defineCustomElement };
